import React from "react";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";

import Attachments from "@components/Attachments";
import Div from "@components/Div";
import Panel from "@components/Panel";
import RichText from "@components/RichText";
import { TextMediumWeight } from "@components/Text";

import { EmailHeader } from "./components";

const Email = props => {
  const { formatMessage } = useIntl();

  const { attachments, secure_body_html, body_html, is_secure_email } = props;

  const shouldShowAttachments = !attachments?.length > 0;
  const bodyToRender = is_secure_email ? secure_body_html : body_html;

  return (
    <Panel header={<EmailHeader {...props} />}>
      {shouldShowAttachments && (
        <Div>
          <Div my={3}>
            <TextMediumWeight>{`${formatMessage({ id: "label_attachments" })}: `}</TextMediumWeight>
          </Div>

          <Attachments showLabel attachments={attachments} />
        </Div>
      )}

      <RichText>{bodyToRender}</RichText>
    </Panel>
  );
};

Email.propTypes = {
  from: PropTypes.string,
  to: PropTypes.string,
  subject: PropTypes.string,
  body_html: PropTypes.string,
  created_at: PropTypes.string,
  direction: PropTypes.string,
  is_secure_email: PropTypes.bool,
  email_reply_classification: PropTypes.string,
  attachments: PropTypes.array,
  secure_body_html: PropTypes.string,
  status: PropTypes.string,
};

export default Email;
